import Displayable from "./index";

const displayableRegistry = {};


class DisplayableFactory {

    constructor() {};

    register(name, clazz) {
        displayableRegistry[name] = clazz;

        return this;
    }

    getDisplayable(implName, config) {

        if(displayableRegistry[implName]) {
            return new displayableRegistry[implName](config);
        } else {
            return new Displayable(config);
        }
        
    }
    
}

export default DisplayableFactory;